const { hot } = require("react-hot-loader/root")

// prefer default export if available
const preferDefault = m => (m && m.default) || m


exports.components = {
  "component---src-pages-404-js": hot(preferDefault(require("G:\\Work\\Primary360\\ahdc-squid\\src\\pages\\404.js"))),
  "component---src-pages-about-js": hot(preferDefault(require("G:\\Work\\Primary360\\ahdc-squid\\src\\pages\\about.js"))),
  "component---src-pages-contact-js": hot(preferDefault(require("G:\\Work\\Primary360\\ahdc-squid\\src\\pages\\contact.js"))),
  "component---src-pages-formspree-trigger-js": hot(preferDefault(require("G:\\Work\\Primary360\\ahdc-squid\\src\\pages\\formspree-trigger.js"))),
  "component---src-pages-index-js": hot(preferDefault(require("G:\\Work\\Primary360\\ahdc-squid\\src\\pages\\index.js"))),
  "component---src-pages-news-js": hot(preferDefault(require("G:\\Work\\Primary360\\ahdc-squid\\src\\pages\\news.js"))),
  "component---src-pages-portfolio-js": hot(preferDefault(require("G:\\Work\\Primary360\\ahdc-squid\\src\\pages\\portfolio.js"))),
  "component---src-pages-strategy-js": hot(preferDefault(require("G:\\Work\\Primary360\\ahdc-squid\\src\\pages\\strategy.js"))),
  "component---src-templates-portfolio-template-js": hot(preferDefault(require("G:\\Work\\Primary360\\ahdc-squid\\src\\templates\\portfolio-template.js")))
}

